export default "__VITE_ASSET__19186e67__"